module.exports = __webpack_public_path__ + "static/media/thumbnail-csohid-bontas-1.6f983480.jpg";